<template>
    <b-row class="my-3 px-1" v-if="bibles">
        <b-col cols="12" lg="4" class="filters mb-4">
            <h6>章を指定して検索</h6>
            <b-row>
                <b-col>
                    <div class="d-flex">
<!--
                        <div class="flex-1">
                            <b-form-select v-model="filters.bible_code" :options="bibles" value-field="bible_code" text-field="bible_name" :select-size="20" @change="onChangeBibleCode"></b-form-select>
                        </div>
-->
                        <div class="flex-2">
                            <b-form-select v-model="filters.book_code" :options="options_books()" value-field="book_code" text-field="book_name" :select-size="20" @change="onChangeBookCode" ref="select_book_code"></b-form-select>
                        </div>
                        <div class="flex-1">
                            <b-form-select v-model="filters.chapter_order" :options="options_chapters()" value-field="chapter_order" text-field="chapter_name" :select-size="20" @change="onChangeChapterOrder" ref="select_chapter_name"></b-form-select>
                        </div>
                    </div>
                </b-col>
            </b-row>

            <h6 class="mt-3">キーワードで検索</h6>
            <b-row>
                <b-col>
                    <div class="d-flex">
                        <b-form @submit.stop.prevent="onSearch">
                            <b-input-group>
                                <b-form-input
                                    v-model="filters.q"
                                    type="search"
                                    />
                                <b-input-group-append>
                                    <b-button type="submit">検索</b-button>
                                </b-input-group-append>
                            </b-input-group>
                        </b-form>
                    </div>
                </b-col>
            </b-row>
        </b-col>

        <b-col cols="12" lg="8" class="result mb-4" id="search-result">
            <h6>
                検索結果
                <template v-if="filters.type === 'chapter'">
                    {{ book(filters.bible_code, filters.book_code).book_name }}
                    {{ chapter(filters.bible_code, filters.book_code, filters.chapter_order).chapter_name }}
                </template>
            </h6>

            <Pagenation
                v-model="filters.page"
                :nb-pages="data.nbPages"
                :nb-hits="data.nbHits"
                @input="pagenation"
                />

            <b-list-group>
                <b-list-group-item v-for="item in data.hits" :key="item.id" :verse_name="item.verse_name" :verse_name_active="item.verse_name === filters.verse_name">
                    <small>
                        <strong>
                            <template v-if="filters.type === 'word'">
                                <a :href="'/' + item.bible_code + '/' + item.book_code + '.' + item.chapter_name + '#' + item.verse_name" target="_blank">
                                {{ book(item.bible_code, item.book_code).book_name }}
                                {{ item.chapter_name }}:{{ item.verse_name }}
                                </a>
                            </template>
                            <template v-else>
                                {{ item.verse_name }}
                            </template>
                        </strong>
                    </small>
                    <br>
                    {{ item.text }}
                </b-list-group-item>
            </b-list-group>

            <Pagenation
                v-model="filters.page"
                :nb-pages="data.nbPages"
                :nb-hits="data.nbHits"
                @input="pagenation"
                v-if="data.nbHits"
                />
        </b-col>
    </b-row>
</template>

<style lang="scss" scoped>
.filters {
    select {
        option::after {
            content: '　';
        /*
            height: 20em !important;
            */
        }
    }
}
#search-result {
    .list-group-item {
        &[verse_name_active="true"] {
            z-index: 2;
            color: #0c5460;
            background-color: #d1ecf1;
            border-color: #bee5eb;
        }
    }
}

.flex-1 {
    flex: 1;
}
.flex-2 {
    flex: 2;
}
h6 {
    font-weight: bold !important;
}
</style>

<script>
import { mapGetters } from 'vuex'
import CalendarInfo from '@/components/CalendarInfo.vue'
import CalendarHtml from '@/components/CalendarHtml.vue'
import CalendarMonth from '@/components/CalendarMonth.vue'
import Pagenation from '@/components/Pagenation.vue'

export default {
    components: {
        CalendarInfo,
        CalendarHtml,
        CalendarMonth,
        Pagenation,
    },
    props: {
    },
    computed: {
        ...mapGetters([
            'auth_level',
            'auth_name',
            'auth_uuid',
            'auth_email',
            'trans',
            'bibles',
            'settings',
        ]),
    },
    data() {
        return {
            filters: {
                bible_code: 'NJ3',
                book_code: 'GEN',
                chapter_order: 0,
                verse_name: null,
                page: 1,
                q: '',
                type: 'chapter',
            },
            data: {},
            error: {
            },
        }
    },
    async mounted() {
//        this.filters.month = this.$moment().format('YYYYMM')
        let pattern = /^\/(.+)\/(.+)\.(\d+)$/mg
        let matches = pattern.exec(this.$route.path)
        if (matches) {
            this.filters.bible_code = matches[1]
            this.filters.book_code = matches[2]
            this.filters.chapter_order = matches[3] - 1
        }
        setTimeout(async () => {
            await this.fetchVerses()
            this.filters.verse_name = location.hash.replaceAll('#', '') || null
        }, 1000)
    },
    methods: {
        pagenation(event) {
            if (event instanceof Event) {
                event.preventDefault()
            }
            this.fetchVerses(this.filters.page)
        },
        async fetchVerses(page) {
            this.filters.page = page || 1

            let filters = {
            }

            switch (this.filters.type) {
                case 'chapter':
                    filters = {
                        bible_code: this.filters.bible_code,
                        book_code: this.filters.book_code,
                        chapter_order: this.filters.chapter_order,
                        verse: this.filters.verse,
                        page: this.filters.page,
                    }
                    break
                case 'word':
                    filters = {
                        bible_code: this.filters.bible_code,
                        q: this.filters.q,
                        page: this.filters.page,
                    }
                    break
            }

            await this.$store
                .dispatch('bible/search', filters)
                .then((response) => {
                    this.$set(this, 'data', JSON.parse(JSON.stringify(response.data.data)))
                    this.filters.verse_name = null

                    this.$nextTick(() => {
                        this.$scrollTo(
                            '#search-result',
                            500
                        )
                    })
                })
                .catch((error) => {
                    this.$set(this, 'data', {})
                })
        },
        options_books () {
            let bible = this.current_bible()
            return bible ? bible.books : []
        },
        options_chapters () {
            let book = this.current_book()
            return book ? book.chapters : []
        },
        current_bible () {
            return this.bible(this.filters.bible_code)
        },
        current_book () {
            return this.book(this.filters.bible_code, this.filters.book_code)
        },
        current_chapter () {
            return this.chapter(this.filters.bible_code, this.filters.book_code, this.filters.chapter_order)
//            let book = this.current_book()
//            let ret = book.chapters.filter((v, i) => {
//                return v.chapter_order === this.filters.chapter_order
//            })
//            return ret.length ? ret[0] : null
        },
        onChangeBibleCode () {
            this.filters.book_code = null
            this.$refs.select_book_code.$el.scrollTop = 0

            this.filters.chapter_order = null
            this.$refs.select_chapter_name.$el.scrollTop = 0
        },
        onChangeBookCode () {
            this.filters.chapter_order = null
            this.$refs.select_chapter_name.$el.scrollTop = 0
        },
        onChangeChapterOrder () {
            this.filters.type = 'chapter'
            this.fetchVerses()
        },
        onSearch () {
            this.filters.type = 'word'
            this.fetchVerses()
        },
//        book(bible_code, book_code) {
        bible(bible_code) {
            let ret = this.bibles.filter((v, i) => {
                return v.bible_code === bible_code
            })
            return ret.length ? ret[0] : null
        },
        book(bible_code, book_code) {
            let bible = this.bible(bible_code)
            let ret = bible.books.filter((v, i) => {
                return v.book_code === book_code
            })
            return ret.length ? ret[0] : null
        },
        chapter(bible_code, book_code, chapter_order) {
            let book = this.book(bible_code, book_code)
            let ret = book.chapters.filter((v, i) => {
                return Number(v.chapter_order) === Number(chapter_order)
            })
            return ret.length ? ret[0] : null
        },
    },
}
</script>

